module.exports = __webpack_public_path__ + "img/facebook.180a6ca6.svg";